<template>
  <div>
      <template v-if="lang=='en' && item.eng_title!='' &&  item.eng_title!=null">
  <b-modal
      v-if="item"
      v-model="modalShow"
      id="modal-scrollable"
      size="lg"
      centered
      scrollable
      :title="item.eng_title"
    >
      <div v-if="item" v-html="item.eng_content"></div>
      <hr  v-if="this.next !=null" />
      <b-container fluid>
          <div class="row" v-if="this.next !=null">
              <div class="col"><span class="float-right">Skip to next after <b-badge variant="warning">{{countDown}}</b-badge> seconds</span></div></div>
          <div class="row">
                <div class="col" v-if="previous!=null"><a  class="float-left" href="javascript:void(0);" @click="goPrevious()"><Previous：{{previous.title}} </a></div>
                <div class="col" v-if="next!=null"><a class="float-right" href="javascript:void(0);" @click="goNext()">{{next.eng_title}}：Next ></a></div>
        </div>
      </b-container>

      <div slot="modal-footer" class="w-100 btn-area">
        <b-button variant="default" size="lg" class="float-right" @click="modalShow=false;clearInterval(stopTimer);">Ok</b-button>
      </div>
    </b-modal>
      </template>
      <template v-else>
  <b-modal
      v-if="item"
      v-model="modalShow"
      id="modal-scrollable"
      size="lg"
      centered
      scrollable
      :title="item.title"
    >
      <div v-if="item" v-html="item.content"></div>
      <hr  v-if="this.next !=null" />
      <b-container fluid>
          <div class="row" v-if="this.next !=null">
              <div class="col"><span class="float-right"><b-badge variant="warning">{{countDown}}</b-badge> 秒後自動跳到下一則。</span></div></div>
          <div class="row">
                <div class="col" v-if="previous!=null"><a  class="float-left" href="javascript:void(0);" @click="goPrevious()">< 上一則：{{previous.title}} </a></div>
                <div class="col" v-if="next!=null"><a class="float-right" href="javascript:void(0);" @click="goNext()">{{next.title}}：下一則 ></a></div>
        </div>
      </b-container>

      <div slot="modal-footer" class="w-100 btn-area">
        <b-button variant="default" size="lg" class="float-right" @click="modalShow=false;clearInterval(stopTimer);">知道了</b-button>
      </div>
    </b-modal>
      </template>


  </div>
</template>

<script>
import * as servicesMixin from "../shared/servicesMixin";
// import bModal from "bootstrap-vue/es/components/modal/modal";
import { bModal } from 'bootstrap-vue'
import { log } from "util";
export default {
  mixins: [servicesMixin],
  props: ["lang"],
  data() {
    return {
      modalShow: false,
      items: null,
      title: "",
      item: null,
      next: null,
      previous: null,
      index: 0,
      countDown:10,
      stopTimer:0,
    };
  },
  mounted() {
    this.init();
  },
  created: function() {},
  methods: {
    init() {
    // /console.log("lang ", this.lang);
      if (this.items == null) {
        this.getOneTimePopupModal().then(res => {
          if (res) {
            this.items = res.data;
            if (this.items.length > 0) {
              this.autofilp();
              this.prepareNext();
              this.showMessage();
            }
          }
        });
      }
    },
    beforeDestroy() {
        clearInterval(this.stopTimer);
    },
    autofilp(){
        this.stopTimer = setInterval(function(){
            if(this.countDown == 0){
                this.goNext();
            }
            this.countDown-=1;
        }.bind(this), 1000);
    },
    goPrevious(){
        if (this.index > 0) {
            this.index -=1;
            this.prepareNext();
        }else{
            this.previous = null;
        }
    },
    goNext(){
        // console.log("next title", this.next.title);
        if (this.index < this.items.length - 1) {
            this.index +=1;
            this.prepareNext();
        }else{
            this.next = null;
        }
    },
    prepareNext() {
        this.countDown = 10;
        this.item = this.items[this.index];
        if (this.index > 0) {
            this.previous = this.items[this.index - 1];
        }else{
            this.previous =     null;
        }
        if (this.index < this.items.length - 1) {
            this.next = this.items[this.index + 1];
        }else{
            this.next = null;
        }
    },
    showMessage() {
      let key = "popup_msg_" + this.item.id;
      if (this.item.one_time_popup == "Y") {
        let cachedItem = sessionStorage.getItem(key);
        // console.log("cached item", cachedItem);
        if (cachedItem == null) {
          this.modalShow = true;
          sessionStorage.setItem(key, JSON.stringify("Y"));
        }
      } else {
        this.modalShow = true;
      }
    }
  }
};
</script>

<style>

.modal-header{

}
.locked {
  color: #007bff;
  cursor: pointer;
}

.modal {
  z-index: 30000 !important;
  width: 97%;
  height:90%;
  margin-top:30px;
}

.modal-title {
  font-size: 26px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif !important;
  color:black;
}

.modal-body {
  font-size: 14px;
  padding: 1.7rem;
}
.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: #0000007d;
}

.btn:focus,
.btn:active {
    outline: none !important;
    box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/mlang/popup-modal/Popup.vue